import { Spinner } from '@/shared/ui'
import { Dashboard } from '@/widgets/dashboard'

type FallbackProps = {
  title: string
  className?: string
}

export const LoadingFallback = ({ title, className }: FallbackProps) => {
  return (
    <Dashboard.Card className={className}>
      <Dashboard.Title>{title}</Dashboard.Title>
      <Dashboard.Content columns={1}>
        <div className="typo-body1 relative flex h-[140px] items-center justify-center text-center font-medium text-gray-400">
          <Spinner />
        </div>
      </Dashboard.Content>
    </Dashboard.Card>
  )
}

export const ErrorFallback = ({ title, className }: FallbackProps) => {
  return (
    <Dashboard.Card className={className}>
      <Dashboard.Title>{title}</Dashboard.Title>
      <Dashboard.Content columns={1}>
        <p className="typo-body1 flex h-[140px] items-center justify-center text-center font-medium text-gray-400">
          오류가 발생했습니다.
          <br />
          잠시 후 다시 시도해 주세요.
        </p>
      </Dashboard.Content>
    </Dashboard.Card>
  )
}
